import React, { useEffect, useState } from 'react';

function Bubbles() {
  const [bubbles, setBubbles] = useState([]);

  useEffect(() => {
    const initialBubbles = Array.from({ length: 15 }, (_, i) => createBubble(i));
    setBubbles(initialBubbles);

    const interval = setInterval(() => {
      setBubbles(prev => {
        const filtered = prev.filter(b => Date.now() - b.createdAt < 8000);
        return [...filtered, createBubble(Date.now())];
      });
    }, 800);

    return () => clearInterval(interval);
  }, []);

  function createBubble(id) {
    const size = Math.random() * 40 + 15;
    return {
      id,
      size,
      left: Math.random() * 100,
      delay: Math.random() * 4,
      duration: Math.random() * 4 + 6,
      createdAt: Date.now()
    };
  }

  return (
    <div className="bubbles-container">
      {bubbles.map(bubble => (
        <div
          key={bubble.id}
          className="bubble"
          style={{
            width: bubble.size,
            height: bubble.size,
            left: `${bubble.left}%`,
            animationDelay: `${bubble.delay}s`,
            animationDuration: `${bubble.duration}s`
          }}
        />
      ))}
    </div>
  );
}

export default Bubbles;
